import { Injectable } from '@angular/core';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class TimeFormatService {
  constructor(private authService: AuthService) {}

  isReady(): boolean {
    // Check if tenant data is loaded - similar to EmojisService.getIsLoaded()
    return this.authService.tenant != null;
  }

  get timeFormat(): string {
    return this.authService.tenant?.use24HourTime ? 'HH:mm' : 'h:mm a';
  }

  get dateTimeFormat(): string {
    return this.authService.tenant?.use24HourTime ? 'MMM d yyyy HH:mm' : 'MMM d yyyy h:mm a';
  }

  get shortDateTimeFormat(): string {
    return this.authService.tenant?.use24HourTime ? 'M/d/yyyy HH:mm' : 'M/d/yyyy h:mm a';
  }

  getFormat(formatType: 'time' | 'dateTime' | 'shortDateTime' | 'date'): string {
    switch (formatType) {
      case 'time':
        return this.timeFormat;
      case 'dateTime':
        return this.dateTimeFormat;
      case 'shortDateTime':
        return this.shortDateTimeFormat;
      case 'date':
        return 'MMM d yyyy';
      default:
        return this.dateTimeFormat;
    }
  }
}
